import React, { PureComponent } from "react"

class SelectDropdownItem extends PureComponent {
  onClick = () => {
    this.props.onClick({
      forLabel: this.props.forLabel,
      value: this.props.itemId,
    })
  }
  render() {
    const { label, customLabel } = this.props

    return (
      <li className="select-dropdown__item">
        <button
          type="button"
          onClick={this.onClick}
          disabled={this.props.disabled}
        >
          {customLabel ? customLabel : label}
        </button>
      </li>
    )
  }
}

SelectDropdownItem.defaultProps = {
  customLabel: null,
}

export default SelectDropdownItem
